/* eslint-disable @typescript-eslint/no-unused-vars */
import { useLazyQuery } from "@apollo/client";
import gql from "graphql-tag";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useForm } from "react-hook-form";
import { useHistory, useLocation } from "react-router";
import { Link } from "react-router-dom";
import { searchPodcastsByTitle, searchPodcastsByTitleVariables } from "../__generated__/searchPodcastsByTitle";

const SEARCH_POCASTS_BY_TITLE = gql`
  query searchPodcastsByTitle($input: SearchPodcastsInput!) {
    searchPodcastsByTitle(input: $input) {
      ok
      error
      totalPages
      totalResults
      podcasts {
        id
        title
        category {
          name
        }
        episodes {
          id
        }
      }
    }
  }
`;

interface ISearchForm {
  query?: string;
}

export const Search = () => {
  const { register, handleSubmit, getValues } = useForm<ISearchForm>({
    mode: "onChange",
  });
  const [page, setPage] = useState(1);
  const [currentQuery, setCurrentQuery] = useState("");
  const location = useLocation();
  const history = useHistory();
  const [queryReadyToStart, { data, loading }] = useLazyQuery<searchPodcastsByTitle, searchPodcastsByTitleVariables>(
    SEARCH_POCASTS_BY_TITLE
  );
  const onNextPageClick = () => setPage((current) => current + 1);
  const onPrevPageClick = () => setPage((current) => current - 1);
  useEffect(() => {
    const [_, query] = location.search.split("?query=");

    setCurrentQuery(query);
    queryReadyToStart({
      variables: {
        input: {
          page: 1,
          query,
        },
      },
    });
  }, [history, location, queryReadyToStart]);
  const onSubmit = () => {
    const { query } = getValues();
    history.push(`/search?query=${query}`);
  };
  return (
    <div>
      <Helmet>
        <title>Search | Pocast</title>
      </Helmet>
      <div className="h-screen bg-black text-white">
        <div className="flex flex-col justify-center items-center text-center pt-10">
          <div className="w-full max-w-screen-sm px-5 text-center flex flex-col justify-between ">
            <div className="relative mb-3 mr-auto">
              <div className="text-left text-3xl tracking-wider leading-10 pb-1 text-purple-700">Search Podcasts</div>
            </div>
            <form onSubmit={handleSubmit(onSubmit)} className="grid gap-3 mt-5  sm:w-96 sm:mx-auto  mb-5 z-10">
              <div className="text-left flex flex-col">
                <label className="mb-2 pl-2 font-bold text-white">Search</label>
                <input
                  {...register("query", {})}
                  name="query"
                  type="text"
                  placeholder="Search"
                  autoComplete="off"
                  className="rounded-lg p-2 border-2 bg-transparent text-lg bg-gray-900 border-purple-200 transition-colors focus:outline-none focus:border-purple-700 mb-1"
                />
              </div>
            </form>
            {!loading && (
              <div className=" sm:w-96 sm:mx-auto pb-20 mx-auto mt-8">
                {data?.searchPodcastsByTitle.podcasts && data.searchPodcastsByTitle.podcasts.length > 0 ? (
                  <div>
                    <div className="flex flex-col w-full">
                      {data?.searchPodcastsByTitle.podcasts?.map((podcast) => (
                        <Link
                          key={podcast.id}
                          to={`/podcast/${podcast.id}`}
                          className="w-full bg-gray-700 flex mb-3 p-3 rounded-lg justify-between items-start hover:bg-gray-800"
                        >
                          <div className="flex flex-col items-start">
                            <div className="py-1 px-2 mb-2 bg-pink-800 rounded-lg text-md">{podcast.category?.name}</div>
                            <div className=" font-bold text-xl text-center tracking-wider mb-2">{podcast.title}</div>
                            <div className="font-semibold text-md text-gray-200 mb-2">
                              Total Episodes: {podcast.episodes ? podcast.episodes.length : 0}
                            </div>
                          </div>
                        </Link>
                      ))}
                    </div>
                    <div className="grid grid-cols-3 text-center max-w-md items-center mx-auto mt-10">
                      {page > 1 ? (
                        <button onClick={onPrevPageClick} className="focus:outline-none font-medium text-2xl">
                          &larr;
                        </button>
                      ) : (
                        <div></div>
                      )}
                      <span>
                        Page {page} of {data?.searchPodcastsByTitle.totalPages}
                      </span>
                      {page !== data?.searchPodcastsByTitle.totalPages ? (
                        <button onClick={onNextPageClick} className="focus:outline-none font-medium text-2xl">
                          &rarr;
                        </button>
                      ) : (
                        <div></div>
                      )}
                    </div>
                  </div>
                ) : (
                  <div className="flex  flex-col justify-center items-center pt-40 text-3xl">
                    {currentQuery && (
                      <div>
                        Podcasts with
                        <p className="font-bold mx-2">{currentQuery}</p>Not Found
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
